import { ComponentProps, FC, PropsWithChildren } from 'react';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import { CatIconInfo } from '@blocks-react/components/Icons/Info';
import { CatHeading } from '@blocks-react/components/Heading';

type CatToolTipProps = ComponentProps<typeof CatTooltip>;

export const VisionLinkTooltip: FC<PropsWithChildren<CatToolTipProps>> = ({
  children,
  ...toolTipProps
}) => {
  return (
    <CatTooltip {...toolTipProps}>
      <CatIconInfo slot="trigger" className="pe-auto" size="sm" />
      <CatHeading variant="footnote-bold">{children}</CatHeading>
    </CatTooltip>
  );
};
